
import CourseScript from './script'
import { Observer } from 'mobx-vue'
import LazyImg from '@/components/lazyImg/index.vue'
import { Component } from 'vue-property-decorator'

@Observer
@Component({
  name: 'CourseComp',
  components: { LazyImg }
})
export default class CourseComp extends CourseScript {}
